import { CreateProjectModal } from 'modules/projects/components/CreateProjectModal';
import { useModalContext } from 'utils/contexts/modal';
import { TemplateUnsavedChangesModal } from './TemplateUnsavedChangesModal';
import { ModalAction, ModalState } from '../types';

export const Modals = () => {
  const { modalState = {} } = useModalContext();
  if (!modalState) return null;

  const { action = null } = modalState as ModalState;
  if (!action) return null;

  return (
    <>
      {action === ModalAction.UNSAVED_CHANGES && <TemplateUnsavedChangesModal />}
      {action === ModalAction.NEW_PROJECT && <CreateProjectModal />}
    </>
  );
};
